class GBScrollSwatch extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    this.desktop = matchMedia('(min-width: 990px)');
    this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const signal = this.controller.signal;
    this.queue = () => {
      if (!this.frame) this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.render();
      });
    };
    this.remeasure = () => {
      this.geometry = null;
      this.queue();
    };
    addEventListener('scroll', this.queue, { passive: true, signal });
    addEventListener('resize', this.remeasure, { passive: true, signal });
    this.desktop.addEventListener('change', this.remeasure, { signal });
    this.reduced.addEventListener('change', this.remeasure, { signal });
    this.observer = new ResizeObserver(this.remeasure);
    const gallery = document.querySelector('.product-information__media');
    if (gallery) {
      this.observer.observe(gallery);
      gallery.addEventListener('load', this.remeasure, { capture: true, signal });
    }
    this.observer.observe(this);
    this.queue();
  }

  measure() {
    const gallery = document.querySelector('.product-information__media');
    const source = gallery && [...gallery.querySelectorAll('img')].find(img => {
      const rect = img.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0;
    });
    const target = this.querySelector('.mix-match__selected-image');
    if (!source || !target || !source.complete || !source.naturalWidth) return false;
    if (this.source !== source) {
      this.source?.classList.remove('gb-scroll-swatch__source-hidden');
      this.source = source;
      this.floating?.remove();
      this.floating = source.cloneNode(false);
      this.floating.removeAttribute('id');
      this.floating.removeAttribute('srcset');
      this.floating.removeAttribute('sizes');
      this.floating.src = source.currentSrc || source.src;
      this.floating.alt = '';
      this.floating.setAttribute('aria-hidden', 'true');
      this.floating.className = 'gb-scroll-swatch__floating';
      this.floating.hidden = true;
      document.body.append(this.floating);
    }
    const a = source.getBoundingClientRect();
    const b = target.getBoundingClientRect();
    if (!b.width || !b.height) return false;
    this.geometry = {
      sourceX: a.left, sourceY: a.top + scrollY, sourceW: a.width, sourceH: a.height,
      targetX: b.left, targetY: b.top + scrollY, targetW: b.width, targetH: b.height
    };
    return true;
  }

  inset() {
    const bar = document.querySelector('gb-header-bar');
    return bar ? Math.min(180, Math.ceil(bar.getBoundingClientRect().height) + 32) : 96;
  }

  render() {
    if (!this.desktop.matches || this.reduced.matches) {
      this.classList.remove('gb-scroll-swatch--ready', 'gb-scroll-swatch--docked');
      this.source?.classList.remove('gb-scroll-swatch__source-hidden');
      if (this.floating) this.floating.hidden = true;
      this.geometry = null;
      return;
    }
    if (!this.geometry && !this.measure()) return;
    const g = this.geometry;
    const inset = this.inset();
    const start = Math.max(0, g.sourceY - inset);
    const dockLine = Math.max(inset, Math.min(innerHeight * .36, innerHeight - g.targetH - 24));
    const end = Math.max(start + 1, g.targetY - dockLine);
    const progress = Math.max(0, Math.min(1, (scrollY - start) / (end - start)));
    this.classList.add('gb-scroll-swatch--ready');
    this.classList.toggle('gb-scroll-swatch--docked', progress >= 1);
    const moving = scrollY > start && progress < 1;
    this.source.classList.toggle('gb-scroll-swatch__source-hidden', scrollY > start);
    this.floating.hidden = !moving;
    if (moving) {
      const x = g.sourceX + (g.targetX - g.sourceX) * progress;
      const width = g.sourceW + (g.targetW - g.sourceW) * progress;
      const height = g.sourceH + (g.targetH - g.sourceH) * progress;
      const settle = Math.max(0, Math.min(1, (progress - .45) / .55));
      const eased = settle * settle * (3 - 2 * settle);
      const y = inset + (dockLine - inset) * eased;
      Object.assign(this.floating.style, {
        left: '0px', top: '0px', width: width + 'px', height: height + 'px',
        transform: 'translate3d(' + x + 'px,' + y + 'px,0)'
      });
    }
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.observer?.disconnect();
    if (this.frame) cancelAnimationFrame(this.frame);
    this.floating?.remove();
    this.source?.classList.remove('gb-scroll-swatch__source-hidden');
    this.controller = null;
  }
}
if (!customElements.get('gb-scroll-swatch')) customElements.define('gb-scroll-swatch', GBScrollSwatch);
